import { Directive, ElementRef, QueryList, ViewChildren, EventEmitter, Output } from '@angular/core';
import { NgModel } from '@angular/forms';
import * as $ from 'jquery';
import { invalid } from 'moment';

//DIRECTIVE REFERENCES: https://bit.ly/2M8j8IE, https://bit.ly/2JWQBJD, https://bit.ly/2tgxBuY, https://bit.ly/2I8ClYf

const REQUIRED_FIELD = "Required field.";
const rf= this;

@Directive({
  selector: "input[ngModel][required], textarea[ngModel][required], select[ngModel][required], input[type='submit'][submitClick], button[submitClick],ng-multiselect-dropdown",
  providers: [NgModel]
})

export class FieldValidationDirective {
  //Allows access to all elements on which directive will apply. Does not work at the moment. Read: https://bit.ly/2I6ZuKL
  @ViewChildren(FieldValidationDirective) viewChildren: QueryList<FieldValidationDirective>;
  //Custom Event to force page validation on all 'required' fields
  @Output() submitClick = new EventEmitter();
  dateValid:boolean = false;

  constructor(private elem: ElementRef, private ngModel: NgModel) {
  }

  ngAfterViewInit() {
    let that = this;
    let errorMsg = REQUIRED_FIELD;
    let errorMsgID = (that.elem.nativeElement.type==='radio') ? that.elem.nativeElement.name + '_errorMsg' : that.elem.nativeElement.id + '_errorMsg';
    // API FOR FUTURE USE ****
     //Listening to the value of ngModel
     that.ngModel.valueChanges.subscribe(function(value) {
      //Do something with the value if required
      if(that.ngModel.model !== undefined || that.ngModel.model !== null){
        //this.dateValid = true;
        $("#"+errorMsgID).remove();
      }
      if(that.elem.nativeElement.name == "currency" && that.ngModel.model == 0){
        //this.dateValid = true;
        $(that.elem.nativeElement).parent().parent(":not(:has([id*='_errorMsg']))").append("<div id='" + errorMsgID + "' role='alert'><small class='form-text text-danger'>"+errorMsg+"</small></div>");
      }
    });

     //Getting access to FormControl, use below
     /*that.ngModel.control

     //For update ngModel update
     that.ngModel.update.emit(undefined);
     ****************************/

    //Case: For ALL fields except submit buttons, add a 'oninput' listener for field-level validation
    if(['radio', 'submit'].indexOf(that.elem.nativeElement.type)===-1 || ['BUTTON'].indexOf(that.elem.nativeElement.tagName)===-1){
      that.elem.nativeElement.addEventListener('input', that.validateField);
    }

    //Case: For a SELECT field, adding an 'onchange' event handler
    if(['radio'].indexOf(that.elem.nativeElement.type)!==-1 || ['SELECT'].indexOf(that.elem.nativeElement.tagName)!==-1){
      that.elem.nativeElement.addEventListener('change', that.validateField);
    }

    //Case: For a TELEPHONE field
    if(that.elem.nativeElement.type==='tel'){
      if(!that.elem.nativeElement.pattern){
        //UI Framework will use the default pattern for telephone number if not provided
        that.elem.nativeElement.pattern = "[0-9]+";
      }
    }

    //Case: For a SUBMIT button, adding an 'onclick' event handler
    if(that.elem.nativeElement.type==='submit'){
      that.elem.nativeElement.addEventListener('click', function($event){
        //Retrieve form fields with required
        let elemList = $("input[required]:visible, textarea[required]:visible, select[required]:visible, ng-multiselect-dropdown[required]:visible").get();

        //Apply validation rules to all elements
        that.dateValid = true;
        for(let i=0; i<elemList.length; i++){
          //elemList[i].data = that;
          that.validateField.call(null, elemList[i],that.dateValid);
        }

        //If no errors, fire 'submitClick' event. Reference: https://bit.ly/2JSpy22
        if($("div[id*='_errorMsg']:visible").length===0){
          that.submitClick.emit();
        } else {
          if (elemList.length > 0) {
            const elem = elemList[0];
            elem.focus();
          } else {
            const elem = $("div[id*='_errorMsg']:visible")[0];
            elem.focus();
          }
        }
      });
    }
  }

  //Function to validate a field using a validation algorithm
  validateField(event){
    let elem: any = this || event;
    let scope: any = event.data;      //Scope of the directive. Has access to ElementRef and NgModel
    let isValid = false;
    let errorMsg = REQUIRED_FIELD;

    //Step 1: Validate against RULES
    if(elem.type==='text' || elem.type==="tel" || elem.type==='password' || elem.tagName==='TEXTAREA'){

      if(elem.name ==='email' && elem.inputmask){
        isValid = (elem.inputmask.unmaskedvalue() === '_@_._')  ? false : true;
      }

      else{
        isValid = (elem.value && elem.value.toString().trim().length > 0) ? true : false;
      }
      /*elem.classList.forEach(element => {
       if(element==="ng-invalid")
       {
        isValid=false;
        errorMsg=""
       }
       if(element==="ng-valid")
       {
        isValid=true;
        errorMsg=""
       }
      });*/

    }
    else if(elem.type==="number"){
      isValid = (elem.value && elem.value.toString().trim().length > 0) ? true : false;
      if(isValid)
      {
        if(elem.min!==undefined && elem.max!==undefined)
        {
          if(Number(elem.value)>=Number(elem.min) && Number(elem.value)<=Number(elem.max))
          {
            isValid=true;
            elem.classList.remove("ng-invalid");
            elem.classList.add("ng-valid");
          }else
          {
            isValid=false;
            errorMsg="Maximum allowable hours is "+elem.max;
            elem.classList.remove("ng-valid");
            elem.classList.add("ng-invalid");
          }
        }
      }
    }
    else if(elem.type==='radio'){
      isValid = $("input[type='radio'][name='" + elem.name + "']").is(":checked") ? true: false;
    }
    else if(elem.type==='email'){
      isValid =  (elem.value && elem.value.trim()) ? true: false;
    }
    else if(elem.tagName==="SELECT"){
      isValid = (elem.value && elem.value.trim() && elem.value.indexOf('undefined')===-1) ? true : false;
    }
    else if (elem.tagName==="NG-MULTISELECT-DROPDOWN") {
      let count =0;
      elem.classList.forEach(element => {
        if(element==="ng-invalid")
        {
         count +=1;
        }
        else{
          count = count;
        }
       });
       if(count >0){
         isValid = false;
       }
       else{
         isValid = true;
       }
      //const value = elem.attributes[9].nodeValue;
      //isValid = (value === null || value === undefined || value === '') ? false : true;
    }

    //Step 2: Retrieve attributes for error message
    let fieldID = elem.id;    //Generate ID if not exists
    let fieldAriaDescribedBy = $(elem).attr("aria-describedby") ? $(elem).attr("aria-describedby") : '';
    let errorMsgID = (elem.type==='radio') ? elem.name + '_errorMsg' : elem.id + '_errorMsg';

    //Step 3: Validate against RULES
    if(isValid) {
      //Remove errorMsg element and error message ID from aria-describedby of field
      $("#"+errorMsgID).remove();

      if(fieldAriaDescribedBy.indexOf(errorMsgID)!==-1){
        if(elem.type==='radio'){
          $("input[type='radio'][name='" + elem.name + "']").removeAttr("aria-describedby");
        }
        else{
          $(elem).removeAttr("aria-describedby");
        }
      }
    }
    else {
      //Append error message there
      //console.log(elem.disabled);
      if(elem == event && !elem.disabled){
        $(elem).parent().parent(":not(:has([id*='_errorMsg']))").append("<div id='" + errorMsgID + "' role='alert'><small class='form-text text-danger'>"+errorMsg+"</small></div>");

      //Add error message ID to aria-describedby of field
      $(elem).attr("aria-describedby", errorMsgID);
      }
      else{
        $("#"+errorMsgID).remove();
      }
      
    }
  }

  validateNgMultiselect(event){
    let elem: any = this || event;
    let scope: any = event.data;      //Scope of the directive. Has access to ElementRef and NgModel
    let isValid = false;
    let errorMsg = REQUIRED_FIELD;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/fieldValidation.directive.ts